// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useState, useEffect, useCallback } from "react";
import { Text } from "@unifize/sarah";
import { connect } from "react-redux";

import { Name as StyledName } from "./styles";
import { SmallText as Input } from "src/styles/input";
import { getUser, getUserRole } from "src/reducers";
import Icon from "src/components/Icon";
import { updateOtherUserDetails } from "src/actions/user";
import { iconSize } from "src/styles/constants/size";
import { sanitizeSquareBrackets } from "src/utils";

import type { AppState, UnifizeUser } from "src/types";

type Props = {
  role: string,
  user: UnifizeUser,
  _updateOtherUserDetails: Function,
};

const Name = ({ role, user, _updateOtherUserDetails }: Props) => {
  const [edit, setEdit] = useState(false);
  const [text, setText] = useState("");
  const [nameError, setNameError] = useState(false);

  useEffect(() => {
    setText(user.displayName);
  }, [user, setText]);

  const handleChange = useCallback(
    (e: any) => {
      const { value } = e.target;
      // Don't allow square brackets in the input
      const { sanitizedValue, hasSquareBrackets } =
        sanitizeSquareBrackets(value);
      setNameError(hasSquareBrackets);
      setText(sanitizedValue);
    },
    [setText],
  );

  const handleSubmit = useCallback(
    (e: any) => {
      e.preventDefault();
      if (!text.trim()) {
        return;
      }
      const { uid } = user;
      _updateOtherUserDetails(uid, {
        displayName: text,
      });

      setEdit(false);
    },
    [user, text, setEdit, _updateOtherUserDetails],
  );

  if (role === "admin" || role === "phantom") {
    return (
      <StyledName onSubmit={handleSubmit}>
        {edit ? (
          <>
            <Input
              value={text}
              placeholder={i18n.t(k.ENTER_DISPLAY_NAME)}
              onChange={handleChange}
              required
            />
            {nameError && (
              <Text variant="pill" color="red">
                {i18n.t(k.SQUARE_BRACKETS_NOT_ALLOWED)}
              </Text>
            )}
          </>
        ) : (
          <span>
            <span>{user.displayName}</span>
            <Icon
              icon="edit"
              onClick={() => setEdit(true)}
              size={iconSize.space_m}
            />
          </span>
        )}
      </StyledName>
    );
  }

  return (
    <StyledName>
      <span>
        <span>{user.displayName}</span>
      </span>
    </StyledName>
  );
};

const mapStateToProps = ({ app }: { app: AppState }, props) => ({
  user: getUser(app, props.uid),
  role: getUserRole(app),
});

export default connect(mapStateToProps, {
  _updateOtherUserDetails: updateOtherUserDetails,
})(Name);
